import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { NavDropdown } from "react-bootstrap";
import { IWhitespaceMenuEntry } from "../../interfaces/Components/WhitespaceMenu/IWhitespaceMenuEntry";
import "./WhitespaceMenu.scss";

export const WhitespaceMenuEntry: React.FC<IWhitespaceMenuEntry> = ({ whitespaceMenuItem, rootReturnUrl, isRootMenu }) => {
  const requiresWindowOpen = (whitespaceMenuItem.url && whitespaceMenuItem.url.toLowerCase().indexOf("window.open") > -1);
  const [targetParams, setTargetParams] = useState<Array<any>>([]);

  if (whitespaceMenuItem.children.length === 0
    && (whitespaceMenuItem.url === undefined || whitespaceMenuItem.url === null || whitespaceMenuItem.url.length === 0)) {
    return <></>;
  }

  useEffect(() => {
    if (whitespaceMenuItem.url && requiresWindowOpen) {
      const { url } = whitespaceMenuItem;
      const splitIndex = url.toLowerCase().indexOf("window.open") + "window.open".length;
      const paramText : string = url.substring(splitIndex);
      const paramSplitArray = paramText.split("'");

      const illegalParams = ["(", ",", ");", ";", ")"];

      const actualParamArray : string[] = [];

      paramSplitArray.forEach((item : string) => {
        if (!illegalParams.includes(item.trim())) {
          actualParamArray.push(item.trim());
        }
      });

      setTargetParams([...actualParamArray]);
    }
  }, [whitespaceMenuItem.url]);

  const handleWindowOpen = () => {
    if (requiresWindowOpen && targetParams.length > 0) {
      const targetUrl = (targetParams[0].toLowerCase().indexOf("http") === -1) ? `${rootReturnUrl}${targetParams[0]}` : targetParams[0];
      window.open.apply(null, [targetUrl, targetParams[1], targetParams[2]]);
    }
  };

  return (
    <>
      {whitespaceMenuItem.children.length > 0 && (
        <NavDropdown
          id={`${whitespaceMenuItem.name}`}
          key={whitespaceMenuItem.name}
          title={whitespaceMenuItem.name}
          className={`me-auto ${!isRootMenu ? "dropend" : ""}`}
          data-testid={`menu_${whitespaceMenuItem.name}`}
        >
          {whitespaceMenuItem.children
      && whitespaceMenuItem.children.map((menuItem, idx) => (
        <WhitespaceMenuEntry
          key={idx}
          whitespaceMenuItem={menuItem}
          rootReturnUrl={rootReturnUrl}
          isRootMenu={false}
        />
      ))}
        </NavDropdown>
      )}

      {(whitespaceMenuItem.children.length === 0) && !requiresWindowOpen && ((
        <NavDropdown.Item href={`${rootReturnUrl}${whitespaceMenuItem.url}`} key={uuidv4()} data-testid={`submenu_${whitespaceMenuItem.name}`}>
          {whitespaceMenuItem.name}
          {" "}
        </NavDropdown.Item>
      ))}
      {(whitespaceMenuItem.children.length === 0) && requiresWindowOpen && (
        <NavDropdown.Item
          href="#"
          onClick={() => { handleWindowOpen(); }}
          key={uuidv4()}
          data-testid={`submenu_${whitespaceMenuItem.name}`}
        >
          {whitespaceMenuItem.name}
          {" "}
        </NavDropdown.Item>
      )}
    </>
  );
};
